<script lang="ts">
  import type ProfileMergeListSection from '$provider/models/ProfileMergeListSection';
  import MergeItem from './MergeItem.svelte';
  import Action from './Action.svelte';
  import Label from '$provider/constants/Label';

  interface Props {
    item: ProfileMergeListSection;
    onalert?: (payload: any) => void;
    onreview?: (payload: any) => void;
    ontoggleadd?: (payload: any) => void;
    onresolveedit?: (payload: any) => void;
    onclickrecord?: (payload: any) => void;
    onaddall?: (payload: ProfileMergeListSection) => void;
    onignoreall?: (payload: ProfileMergeListSection) => void;
  }

  let { item, onalert, onreview, ontoggleadd, onresolveedit, onclickrecord, onaddall, onignoreall }: Props = $props();

  const onAddAll = (): void => {
    onaddall?.(item);
  };

  const onIgnoreAll = (): void => {
    onignoreall?.(item);
  };
</script>

<div data-cy="merge-section" class="merge-section">
  <div data-cy="merge-section-head" class="head">
    <div data-cy="merge-section-title" class="title">{item?.title}</div>
    {#if item.hasNoChildren}
      <div class="action">
        <Action item={item.list.first()} {onreview} {ontoggleadd} />
      </div>
    {:else if item.allowBulkAction}
      <div class="text-action">
        <button class="text-action-i" onclick={(e) => { e.stopPropagation(); onAddAll(); }}>{Label.AddAll}</button>
        <button class="text-action-i" onclick={(e) => { e.stopPropagation(); onIgnoreAll(); }}>
          {Label.IgnoreAll}
        </button>
      </div>
    {/if}
  </div>
  {#if !item.hasNoChildren && item.list.length !== 0}
    <div data-cy="merge-list" class="list">
      {#each item.list as child}
        <MergeItem item={child} {onalert} {onreview} {ontoggleadd} {onresolveedit} {onclickrecord} />
      {/each}
    </div>
  {/if}
</div>

<style>
  .merge-section {
    background-color: #ffffff;
    border: 1px solid rgba(0, 0, 0, 0.07);
    border-radius: 2px;
    padding: 16px 20px;
  }
  .merge-section:not(:last-child) {
    margin-bottom: 16px;
  }
  .head {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .title {
    font-size: 16px;
    font-weight: 600;
    line-height: 22px;
  }
  .list {
    margin-top: 20px;
  }

  .text-action {
    display: flex;
    align-items: end;
    justify-content: end;
    margin-top: 8px;
  }
  .text-action .text-action-i {
    font-size: 11px;
    line-height: 18px;
    color: var(--blue);
    cursor: pointer;
  }
  .text-action .text-action-i:hover {
    opacity: 0.7;
  }
  .text-action .text-action-i:not(:last-child) {
    margin-right: 8px;
  }
</style>
